export default function svgBlackX({ color }: { color?: string }): JSX.Element {
    return (
        <>
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6.00005L6 18" stroke={color || "white"} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 6.00005L18 18" stroke={color || "white"} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </>
    );
}